export enum ProjectCardBehaviour {
    Default = 'default',
    Static = 'static',
    Custom = 'custom'
}

const DEFAULT_CARD_BEHAVIOR = ProjectCardBehaviour.Default
const DEFAULT_CUSTOM_CARD_POSITION = {
    top: 50,
    left: 50,
    right: null,
    bottom: null
}

export function useCardBehaviour(
    WrapperElement,
    cardBehaviorProp: ProjectCardBehaviour = DEFAULT_CARD_BEHAVIOR,
    customCardPosition = DEFAULT_CUSTOM_CARD_POSITION
) {
    const cardBehavior = cardBehaviorProp
    const cardPositionCustom = customCardPosition

    const mousePositionAttributes = ref()
    const displayCard = ref(false)
    const updateCardPosition = (mouseEvent, position) => {
        if (WrapperElement.value === null) return
        const wrapperRectangle = WrapperElement.value.getBoundingClientRect()

        if (!wrapperRectangle) return
        const target = mouseEvent.target

        if (target.tagName === 'path') {
            const targetPathRectangle = target.getBoundingClientRect()
            displayCard.value = true
            mousePositionAttributes.value = {
                target,
                targetPathRectangle,
                wrapperRectangle,
                position
            }
        } else {
            displayCard.value = false
        }
    }

    const cardStyle = computed(() => {
        let styleToReturn = {}

        if (!displayCard.value) {
            styleToReturn = {
                display: 'none'
            }
            return styleToReturn
        }

        if (cardBehavior === ProjectCardBehaviour.Default) {
            styleToReturn = {
                position: 'absolute',
                top: `${mousePositionAttributes.value.position.y - 30}px`,
                left: `${mousePositionAttributes.value.position.x + 30}px`
            }
        }

        if (cardBehavior === ProjectCardBehaviour.Static) {
            let left =
                mousePositionAttributes.value.targetPathRectangle.x -
                mousePositionAttributes.value.wrapperRectangle.x +
                mousePositionAttributes.value.targetPathRectangle.width

            if (left + 200 > window.innerWidth) {
                left =
                    mousePositionAttributes.value.targetPathRectangle.x -
                    mousePositionAttributes.value.wrapperRectangle.x -
                    200
            }

            styleToReturn = {
                position: 'absolute',
                top: `${
                    mousePositionAttributes.value.targetPathRectangle.y -
                    mousePositionAttributes.value.wrapperRectangle.y
                }px`,
                left: `${left}px`
            }
        }

        if (cardBehavior === ProjectCardBehaviour.Custom) {
            let customPosition

            if (cardPositionCustom.left) {
                customPosition = {
                    top: `${cardPositionCustom.top}%`,
                    left: `${cardPositionCustom.left}%`
                }
            } else if (cardPositionCustom.right) {
                customPosition = {
                    right: `${cardPositionCustom.right}%`,
                    bottom: `${cardPositionCustom.bottom}%`
                }
            } else {
                customPosition = {
                    top: `${cardPositionCustom.top}%`,
                    left: `${cardPositionCustom.left}%`
                }
            }

            styleToReturn = {
                position: 'absolute',
                ...customPosition
            }
        }

        return styleToReturn
    })

    const helperDivStyle = computed(() => {
        if (displayCard.value) {
            let styleToReturn = {
                position: 'absolute',
                border: '3px solid yellow',
                width: `${mousePositionAttributes.value.targetPathRectangle.width}px`,
                height: `${mousePositionAttributes.value.targetPathRectangle.height}px`,
                top: `${
                    mousePositionAttributes.value.targetPathRectangle.y -
                    mousePositionAttributes.value.wrapperRectangle.y
                }px`,
                left: `${
                    mousePositionAttributes.value.targetPathRectangle.x -
                    mousePositionAttributes.value.wrapperRectangle.x
                }px`,
                zIndex: 4
            }

            if (cardBehavior === ProjectCardBehaviour.Custom) {
                const customPosition = {
                    top: `${cardPositionCustom.top}%`,
                    left: `${cardPositionCustom.left}%`
                }

                styleToReturn = {
                    ...styleToReturn,
                    ...customPosition
                }
            }

            return styleToReturn
        } else {
            return {
                display: 'none'
            }
        }
    })

    return {
        mousePositionAttributes,
        displayCard,
        cardBehavior,
        cardPositionCustom,
        cardStyle,
        helperDivStyle,
        updateCardPosition
    }
}
